export const MENU = [
    {
        "id": "84fc017cff7647d98c3af3f264a3002c",
        "icon": ['fas', 'user-cog'],
        "titre": "admin",
        "path": "admin",
        "sousMenu": {
            "exists": false
        }
    },
    {
        "id": "98549602a1874596a7ac985d579fb19d",
        "icon": ['fas', 'user-secret'],
        "titre": "arbitres",
        "path": "arbitres",
        "sousMenu": {
            "exists": false
        }
    },
    {
        "id": "8503871f262d4f35b46f844239125970",
        "icon": ['fas', 'newspaper'],
        "titre": "articles",
        "path": "articles",
        "sousMenu": {
            "exists": false
        }
    },
    {
        "id": "53257bd74ee34d9e98d2737eea287db5",
        "icon": ['fas', 'child'],
        "titre": "buteurs",
        "path": "buteurs",
        "highlight": true,
        "sousMenu": {
            "exists": false
        }
    },
    {
        "id": "39e50253586d46ccacb79564348e7a61",
        "icon": ['fas', 'file'],
        "titre": "cartons",
        "path": "cartons",
        "highlight": true,
        "sousMenu": {
            "exists": false
        }
    },
    {
        "id": "eb554ab694df484fa6b07222b312ab48",
        "icon": ['fas', 'globe'],
        "titre": "championnats",
        "path": "championnats",
        "sousMenu": {
            "exists": false
        }
    },
    {
        "id": "e43a3393f4674ca8959bc21a9dfaaacc",
        "icon": ['fas', 'poll'],
        "titre": "classements",
        "highlight": true,
        "path": "classements",
        "sousMenu": {
            "exists": false
        }
    },
    {
        "id": "b24e79c7beb14bcea22b70fa573112d1",
        "icon": ['fas', 'users'],
        "titre": "equipes",
        "path": "equipes",
        "sousMenu": {
            "exists": false
        }
    },
    {
        "id": "6d1840c5a2984e03946ff3216e574c33",
        "icon": ['fas', 'running'],
        "titre": "joueurs",
        "path": "joueurs",
        "sousMenu": {
            "exists": false
        }
    },
    {
        "id": "70d164123f264b4c9101d3e6522606a9",
        "icon": ['fas', 'calendar-alt'],
        "titre": "matchs",
        "path": "matchs",
        "highlight": true,
        "sousMenu": {
            "exists": false
        }
    },
    {
        "id": "173648e5-ffb9-4f7e-bb22-a290300b4bdf",
        "icon": ['fas', 'envelope'],
        "titre": "messages",
        "path": "messages",
        "sousMenu": {
            "exists": false,
        }
    },
    {
        "id": "d7e7ea9ba8c243a5b7477285c418f1ee",
        "icon": ['fas', 'registered'],
        "titre": "resultats",
        "path": "resultats",
        "highlight": true,
        "sousMenu": {
            "exists": false
        }
    },
    {
        "id": "0592a9eb-bac0-4633-9a2d-b4f2412bca89",
        "icon": ['fas', 'envelope'],
        "titre": "saisons",
        "path": "saisons",
        "sousMenu": {
            "exists": false,
        }
    },
    {
        "id": "15b06129b9f44d78adb33a8cbb728298",
        "icon": ['fas', 'users-cog'],
        "titre": "staffs",
        "path": "staffs",
        "sousMenu": {
            "exists": false
        }

    },
    {
        "id": "d1e5942c-6504-42fe-9b29-4c80c01e7430",
        "icon": ['fas', 'envelope'],
        "titre": "terrains",
        "path": "terrains",
        "sousMenu": {
            "exists": false,
        }
    },
]


// WEBPACK FOOTER //
// ./src/data/menu.js